module.exports = __webpack_public_path__ + "img/ifgoiano-horizontal-preto.33e39477.svg";